<template>
  <div>
    <div class="card">
      <div class="card-header">Find Location</div>
      <div class="card-body">
        <form>
          <div class="form-group row">
            <label for="location" class="col-sm-2 col-form-label"
              >Location</label
            >
            <div class="col-sm-8">
              <b-form-input
                type="text"
                :formatter="upper"
                v-model.trim="find"
                id="find"
                placeholder="Location"
                v-on:keyup.enter="doSearch"
              />
            </div>
            <div class="col-sm-2">
              <button type="button" @click="doSearch" class="btn btn-primary">
                Search
              </button>
            </div>
          </div>
        </form>
        <b-row class="table-responsive" v-if="inventory.length > 0">
          <b-table
            :items="inventory"
            :fields="headers"
            responsive="sm"
            primary-key="bundle"
            striped
            small
          >
          </b-table>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { bundleInventory } from "../../api/bundleinventory";
import { mapGetters, mapActions } from "vuex";
import textutils from "../../textutils";

export default {
  data() {
    return {
      find: null,
      bundle: null,
      inventory: [],
      headers: [
        { key: "location", label: "Location" },
        { key: "bundle", label: "Bundle" },
        { key: "quantity", label: "Qty" },
      ],
    };
  },
  computed: {
    ...mapGetters("invBundles", ["facility"]),
  },
  methods: {
    ...mapActions("common", ["showLoadingDuringAction"]),
    doSearch() {
      let i = bundleInventory.findInventoryByLocation(this.facility, this.find);
      this.showLoadingDuringAction(i).then((res) => {
        this.inventory = res.data.payload;
        this.find = null;
      });
    },
    upper(t) {
      return textutils.toUpper(t);
    },
  },
};
</script>

<style scoped></style>
